import { render, staticRenderFns } from "./OkTable.vue?vue&type=template&id=7515f0b4&"
import script from "./OkTable.vue?vue&type=script&lang=js&"
export * from "./OkTable.vue?vue&type=script&lang=js&"
import style0 from "./OkTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports